var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("strong", [_vm._v(_vm._s(_vm.$_.get(_vm.activity, "actor")))]),
    _vm._v(" :\n    "),
    _c("strong", [
      _vm._v(_vm._s(_vm.$_.get(_vm.activity, "payload.channelName"))),
    ]),
    _vm._v(" state changed form\n    "),
    _c("strong", [
      _vm._v(_vm._s(_vm.$_.get(_vm.activity, "payload.oldState"))),
    ]),
    _vm._v(" to\n    "),
    _c("strong", [
      _vm._v(_vm._s(_vm.$_.get(_vm.activity, "payload.newState"))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }